import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";

function Impressum() {
  return (
    <div className="page-bg">
      <header className="header">
        <h1 className="display-4">Impressum</h1>
        <p className="lead">gemäß § 14 UGB und § 5 ECG</p>
      </header>

      <main className="container my-5">
        <div className="bg-white p-4 rounded shadow-sm">
          <p>
            <strong>ESV - Bludenz</strong><br />
            Eisenbahnersportverein Bludenz<br />
            Landstraße 10<br />
            6714 Nüziders<br />
            Österreich
          </p>
          <p>
            <strong>Obmann:</strong><br />
            Ernst Lerch <br />
            ZVR-Zahl: 301152401<br />
          </p>
          <p>
            Vereinssitz: Bludenz, Österreich<br />
            Vereinszweck: Förderung des Sports im Sinne der Statuten  <br />
            E-Mail: ernst.lerch@lampertmail.at<br />
          </p>
          <p>
            <strong>Medieninhaber & für den Inhalt verantwortlich: </strong><br />
            Ernst Lerch<br />  
            Landstraße 10<br />  
            6714 Nüziders<br />  
          </p>
          <p>
          Plattform der EU-Kommission zur Online-Streitbeilegung: <br />  
          https://ec.europa.eu/odr <br />  
          </p>

          <div className="mt-4 text-center">
            <Link to="/" className="btn btn-impressum">
              Zurück zur Sektionsübersicht
            </Link>
          </div>
        </div>
      </main>

      <footer className="footer">
        © {new Date().getFullYear()} ESV Bludenz – Ein Verein für alle Eisenbahner:innen
      </footer>
    </div>
  );
}

export default Impressum;
